import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

export default function BlogList() {
  const [posts, setPosts] = useState(null);
  useSEO(
    "Sangha — The NAKSRA Community | NAKSRA",
    "Sangha is the NAKSRA community journal: articles on Nakshatras, dasha timing, and applying 5,000-year-old Jyotish methods to modern career, money, relationship and relocation decisions."
  );

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#050507] text-[#F8F9FA]">
      <Navbar />
      <main className="mx-auto max-w-5xl px-6 py-20">
        <p className="text-xs font-medium uppercase tracking-[0.35em] text-[#D4AF37]">The NAKSRA Community</p>
        <h1 className="mt-4 font-heading text-4xl font-medium tracking-tight sm:text-5xl">Sangha</h1>
        <p className="mt-6 max-w-2xl leading-relaxed text-[#A1A1AA]">
          Whereas the word NAKSRA is an ancient rendering of the word NAKSHATRA (which refers to a lunar mansion in Vedic astrology or Jyotish), SANGHA is a gathering place for this NAKSRA community. It displays essays on Nakshatra astrology, dasha timing, and how to apply Jyotish to real life-pivot decisions — published by our astrologers and Jyotish gurus who have endorsed our services, and are open for everyone to read. Member posting and discussion are coming soon.
        </p>

        <div className="mt-14 space-y-6" data-testid="blog-list">
          {posts === null ? (
            <p className="text-[#A1A1AA]">Loading articles…</p>
          ) : posts.length === 0 ? (
            <div className="rounded-lg border border-white/10 bg-[#0C0C10] p-12 text-center text-[#A1A1AA]" data-testid="blog-empty">
              No articles published yet. Check back soon.
            </div>
          ) : (
            posts.map((p, i) => (
              <motion.article
                key={p.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                className="group rounded-lg border border-white/10 bg-[#0C0C10] p-8 transition-colors duration-300 hover:border-[#D4AF37]/40"
                data-testid={`blog-card-${p.slug}`}
              >
                <p className="text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
                  {new Date(p.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
                </p>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-link-${p.slug}`}>
                  <h2 className="mt-3 font-heading text-2xl font-medium tracking-tight transition-colors duration-300 group-hover:text-[#D4AF37] sm:text-3xl">
                    {p.title}
                  </h2>
                </Link>
                <p className="mt-3 leading-relaxed text-[#A1A1AA]">{p.excerpt}</p>
                <Link to={`/blog/${p.slug}`} className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#D4AF37] transition-colors duration-300 hover:text-[#FBE18D]">
                  Read article <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </motion.article>
            ))
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
